/*
 * Copyright (c) Axiata Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";
import Navbar from "react-bootstrap/Navbar";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";
import { Link } from "react-router-dom";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {
  const isAuthenticated = useIsAuthenticated();
  const fullYear = new Date().getFullYear();

  return (
    <>
      <Navbar bg="primary" variant="dark">
        <a className="navbar-brand" href="/">
          Axiata Digital Business Card
        </a>
        {isAuthenticated ? <SignOutButton /> : <SignInButton />}
      </Navbar>
      <br />
      {props.children}
      <div className="footer">
        <div className="">
          <footer className="w-100 py-1 flex-shrink-0">
            <div className="container py-2">
              <div className="row">
                <div className="col-md-12">
                  <p className="small mb-0">
                    &copy; Copyrights {fullYear} Axiata Group, All rights
                    reserved.{" "}
                  </p>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};
